var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83333 8.66666C8.09695 8.66666 7.5 9.26361 7.5 9.99999V33.3333C7.5 34.0697 8.09695 34.6667 8.83333 34.6667H32.1667C32.903 34.6667 33.5 34.0697 33.5 33.3333V9.99999C33.5 9.26361 32.903 8.66666 32.1667 8.66666H8.83333ZM4.75 9.99999C4.75 7.05447 5.88781 5.91666 8.83333 5.91666H32.1667C35.1122 5.91666 36.25 7.05447 36.25 9.99999V33.3333C36.25 36.2788 35.1122 37.4167 32.1667 37.4167H8.83333C5.88781 37.4167 4.75 36.2788 4.75 33.3333V9.99999Z",
    fill: "#2D6772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.375 2.5C28.4105 2.5 29.25 3.23453 29.25 4.14062V9.60938C29.25 10.5155 28.4105 11.25 27.375 11.25C26.3395 11.25 25.5 10.5155 25.5 9.60938V4.14062C25.5 3.23453 26.3395 2.5 27.375 2.5Z",
    fill: "#2D6772"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.625 2.5C14.6605 2.5 15.5 3.23453 15.5 4.14062V9.60938C15.5 10.5155 14.6605 11.25 13.625 11.25C12.5895 11.25 11.75 10.5155 11.75 9.60938V4.14062C11.75 3.23453 12.5895 2.5 13.625 2.5Z",
    fill: "#2D6772"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 16.25C5.5 15.5596 6.29009 15 7.26471 15H33.7353C34.7099 15 35.5 15.5596 35.5 16.25C35.5 16.9404 34.7099 17.5 33.7353 17.5H7.26471C6.29009 17.5 5.5 16.9404 5.5 16.25Z",
    fill: "#2D6772"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68b15bd7ee136b59f9014cc56f043870.svg";
export { ForwardRef as ReactComponent };